<template>
  <b-card>
    <b-row>
      <b-col md="6">
        <h3>{{ $route.name }}</h3>

        <!-- breadcrumb -->
        <b-breadcrumb>
          <b-breadcrumb-item
            ><router-link to="/dashboard/">Dashboard</router-link></b-breadcrumb-item
          >
          <b-breadcrumb-item active>{{ $route.name }}</b-breadcrumb-item>
        </b-breadcrumb>
        <!-- end breadcrumb -->
      </b-col>
      <b-col md="6">
        <b-button :to="'initial-account-balance/create'"
              variant="warning"
              class="btn-back float-right mt-3"
              type="submit"
              ><font-awesome-icon icon="plus"></font-awesome-icon>
              Add Balance
            </b-button>
      </b-col>
    </b-row>
    <b-row class="mt-3 mb-5">
      <b-col md="6">
        <h6 class="text-bold">Assets : </h6>
        <table class="w-100 mt-3">
          <thead class="table-bordered bg-white">
            <tr>
              <th>Account</th>
              <th class="text-center">Currency</th>
              <th class="text-center">Initial Balance</th>
              <th class="text-center">Balance Now</th>
            </tr>
          </thead>
          <tbody class="table-bordered">
            <tr v-for="( asset, i ) in dataAssets" :key="i">
              <td class="w-50 px-2">{{  asset.codeName}}</td>
              <td class="text-center" style="width: 15%;">
                {{ asset.currency}}
              </td>
              <td class="w-auto">
               <money v-bind="money" readonly v-model="asset.totalBalance" required class="text-center bg-white form-control text-right" style="border:none; text-align: right !important;" placeholder="Price" />
              </td>
               <td class="w-auto">
               <money v-bind="money" readonly v-model="asset.balanceNow" required class="text-center form-control bg-white text-right" style="border:none; text-align: right !important;" placeholder="Price" />
              </td>
            </tr>
          </tbody>
        </table>
        <div class="d-flex float-right mt-3">
          <div class="d-block justify-content-center">
            <label for="" class="labels px-3 mt-2">Total Balance ( {{model.currency}} )</label>
            <money v-bind="money" readonly :value="assetsTotal()" required class="text-center form-control bg-white text-right" style="text-align: right !important;" placeholder="Price" />
          </div>
          <div class="d-block justify-content-center">
            <label for="" class="labels px-3 mt-2">Total Balance Now ( {{model.currency}} )</label>
            <money v-bind="money" readonly :value="assetsTotalNow()" required class="text-center form-control bg-white text-right" style="text-align: right !important;" placeholder="Price" />
          </div>
        </div>
      </b-col>
      <b-col md="6">
        <h6 class="text-bold">Liabilities & Capital</h6>
         <table class="w-100 mt-3">
          <thead class="table-bordered bg-white">
            <tr>
              <th>Account</th>
              <th class="text-center">Currency</th>
              <th class="text-center">Initial Balance</th>
              <th class="text-center">Balance Now</th>
            </tr>
          </thead>
          <tbody class="table-bordered">
            <tr v-for="(capital, i) in dataCapitals" :key="i">
              <td class="w-50 px-2">{{ capital.codeName }}</td>
              <td class="text-center" style="width: 15%;">
                {{ capital.currency}}
              </td>
              <td class="w-auto">
               <money v-bind="money" readonly :value="capital.totalBalance" required class="text-center bg-white align-items-center form-control text-right" style="border:none; text-align: right !important;" placeholder="Price" />
              </td>
              <td class="w-auto">
               <money v-bind="money" readonly :value="capital.balanceNow" required class="text-center bg-white align-items-center form-control text-right" style="border:none; text-align: right !important;" placeholder="Price" />
              </td>
            </tr>
          </tbody>
        </table>
        <div class="d-flex float-right mt-3">
          <div class="d-block justify-content-center">
            <label for="" class="labels px-3 mt-2">Total Balance ( {{model.currency}} )</label>
            <money v-bind="money" readonly :value="capitalsTotal()" required class="text-center bg-white form-control text-right" style="text-align: right !important;" placeholder="Price" />
          </div>
          <div class="d-block justify-content-center">
            <label for="" class="labels px-3 mt-2">Total Balance Now ( {{model.currency}} )</label>
            <money v-bind="money" readonly :value="capitalsTotalNow()" required class="text-center bg-white form-control text-right" style="text-align: right !important;" placeholder="Price" />
          </div>
        </div>
      </b-col>
    </b-row>
    <!-- <b-row class="mt-5 mb-4 pb-2">
      <b-col md="6"></b-col>
        <b-col md="6">
          <div v-if="loadingButton" class="float-right">
            <b-button variant="warning" disabled>
              <b-spinner small type="grow"></b-spinner>
              Loading...
            </b-button>
          </div>
          <div v-else>
            <b-button :to="'initial-account-balance/create'"
              variant="warning"
              class="btn-back float-right"
              type="submit"
              ><font-awesome-icon icon="plus"></font-awesome-icon>
              Add Balance
            </b-button>
          </div>
        </b-col>
    </b-row> -->
  </b-card>
</template>

<script>
import {Money} from 'v-money';
export default {
  components: {Money},
  data () {
    return {
      loadingButton: false,
      apiUrl: {
        initialBalance: window.AppConfig.apiUrl + 'get-initial-account-balance'
      },
      model: {
        ammountAssets: 0,
        ammount2: 0,
        assets: [],
        liabilitiesAndCapital: [],
        currency: '',
      },

      dataAssets: [],
      dataCapitals: [],
       //formatter curency
      money: {
          thousands: '.',
          prefix: '',
          suffix: '',
          precision: 0,
          masked: false
        },
    }
  }, 

  mounted(){
    this.getJournalAccount()
  },
  methods: {

  getJournalAccount(){
    this.$http.get(this.apiUrl.initialBalance + '?token=' + this.$store.getters['account/tokens'].access_token).then(response => {
      this.model.currency = response.data.assets !== null ? response.data.assets[0].currency : '-'
      this.model.assets = response.data.assets
      this.model.liabilitiesAndCapital = response.data.liabilitiesAndCapital
      this.dataAssets = response.data.assets.map((asset)=> ({
        codeName: asset.journalAccountCode + ' ' + asset.journalAccountName,
        totalBalance: asset.journalAccountBalance,
        balanceNow: asset.journalAccountBalanceNow,
        uuid: asset.uuid,
        currency: asset.currency
      }))
      this.dataCapitals = response.data.liabilitiesAndCapital.map((capital) => ({
        codeName: capital.journalAccountCode + ' ' + capital.journalAccountName,
        totalBalance: capital.journalAccountBalance,
        balanceNow: capital.journalAccountBalanceNow,
        uuid: capital.uuid,
        currency: capital.currency
      }))
    })
  },

  assetsTotal(){
    let total = 0
    this.dataAssets.forEach(({ totalBalance }) => {
      total = total + (totalBalance ++)
    });
    return total;
  },

   assetsTotalNow(){
    let total = 0
    this.dataAssets.forEach(({ balanceNow }) => {
      total = total + (balanceNow ++)
    });
    return total;
  },

   capitalsTotal(){
    let total = 0
    this.dataCapitals.forEach(({ totalBalance }) => {
      total = total + (totalBalance ++)
    });
    return total;
  },

   capitalsTotalNow(){
    let total = 0
    this.dataCapitals.forEach(({ balanceNow }) => {
      total = total + (balanceNow ++)
    });
    return total;
  },
    

    goBack(){
      window.goBack(this)
    }
  }
}
</script>
<style>
.bg-table{
  background-color: #d3d3d3;
}
</style>